import React from 'react';
import PropTypes from 'prop-types';
import { clickEvents } from '../../../../utils/analytics';

const ResumeAttachment = ({ link }) => {

  const viewMyResumeAnalytics = () => {
    clickEvents.candidateOverlayProfileInteraction('view my resume');
  };

  return link ? (
    <a
      className="slm-profile-resume-attachment__root"
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="resume attachment"
      onClick={viewMyResumeAnalytics}
    >
      <img
        src="https://assets.thdstatic.com/images/v1/path-to-pro/file-document.svg"
        alt="resume attachment"
      />
      <span className="slm-profile-resume-attachment__label">
        VIEW MY RESUME
      </span>
    </a>
  ) : null;
};

ResumeAttachment.propTypes = {
  link: PropTypes.string.isRequired
};

export default ResumeAttachment;
